import React, { useEffect, useState } from "react";
import {
  ICreateSalesData,
  InventoryItem,
  ItemInput,
  IInventory,
} from "../../../../@types";
import { ServiceData } from "../../../../@types/service";
import PlusBoxIcon from "../../../../assets/icons/PlusBoxIcon";
import {
  INVOICE_TABLE_HEADER,
  SERVICE_TABLE_HEADER,
} from "../../../../constants/invoice";
import { InvoiceErrors } from "../../../../modules/validateInvoiceForm";
import { useUserStore } from "../../../../state";
import {
  LineItemTable,
  TableColumn,
} from "../../../common/LineItemTable/InventoryLineItemTable";
import { ServiceLineItemTable } from "../../../common/LineItemTable/ServiceLineItemTable";
import CreateInventoryModal from "../../invoice/inventory/CreateInventoryModal";
import FullScreenOverlay from "../../invoice/inventory/FullScreenModal";
import CreateServiceModal from "../../invoice/services/CreateServiceModal";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "../../../../state/useCompanyStore";
import { VariationItem } from "../../../../@types/inventory";
import ShowSelectedItem, {
  InventoryFormData,
} from "../../../Invoice/sections/LineItemsSection/ShowSelectedItem";
import { formatCurrencyMoney } from "../../../../utils";
import { useInventoryStore } from "../../../../state/useInventoryStore";
import SelectItem from "../../../Invoice/sections/LineItemsSection/SelectItem";
import AddInventory from "../../../Invoice/sections/LineItemsSection/AddInventory";
import ProductOptions from "../../../Invoice/sections/LineItemsSection/ProductOptions";
import ProductVariants from "../../../Invoice/sections/LineItemsSection/ProductVariants";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import ViewSelectItems from "../../../Invoice/sections/LineItemsSection/ViewSelectItems";
import LineItemsSection from "../../../Invoice/sections/LineItemsSection";

interface SalesItemDetailsProps {
  formData: ICreateSalesData;
  updatedNewItem?: ItemInput;
  setFormData: React.Dispatch<React.SetStateAction<ICreateSalesData>>;
  invoiceNo?: string;
  quoteNo?: string;
  validationResults: InvoiceErrors;
  setValidationResults: React.Dispatch<React.SetStateAction<InvoiceErrors>>;
  selectedCurrencyLabel: string;
  items: ItemInput[];
  addItem: () => void;
  setItems: any;
  removeItem: (index: any) => void;
  updateCell: (
    index: number,
    field: string | number,
    value: string | number,
  ) => void;
  updateRow: (index: number, item: ItemInput, quantity?: number) => void;
  serviceType: "time-based" | "session-based";
}

export interface Option {
  name: string;
  type: string[];
}

const LineTable: React.FC<SalesItemDetailsProps> = ({
  formData,
  setFormData,
  invoiceNo,
  quoteNo,
  validationResults,
  selectedCurrencyLabel,
  setValidationResults,
  items,
  addItem,
  setItems,
  removeItem,
  updateCell,
  updateRow,
  serviceType,
}) => {
  const { t } = useTranslation("invoices");
  const columns: TableColumn[] = INVOICE_TABLE_HEADER;
  const column: TableColumn[] = SERVICE_TABLE_HEADER;
  const userStore = useCompanyStore();
  const isRetail = userStore.isRetailBusiness();
  const [showCreateService, setShowCreateService] = useState(false);
  const [showCreateInventory, setShowCreateInventory] = useState(false);

  const handleClearErrors = () => {
    setValidationResults((prevResults) => ({
      ...prevResults,
      inventories: "",
      services: "",
    }));
  };

  const handleAddInventory = () => {
    setShowCreateInventory(true);
  };

  const handleAddService = () => {
    setShowCreateService(true);
  };

  const handleCreateSuccess = (newItem: ItemInput) => {
    const indexOfEmptyRow = items.findIndex((item) => !item.id);

    if (indexOfEmptyRow !== -1) {
      updateRow(indexOfEmptyRow, newItem);
    } else {
      newItem.quantity = 1;
      setItems((prevItems: any) => [...prevItems, newItem]);
    }

    setShowCreateInventory(false);
  };

  const handleCreateServiceSuccess = (newService: ServiceData) => {
    const newItem: ItemInput = {
      id: newService.id || "",
      name: newService.name,
      price:
        newService.price?.length > 0
          ? // @ts-ignore
            parseFloat(newService.price[0].amount)
          : 0,
      duration: newService.duration,
      serviceType: newService.serviceType,
    };

    const indexOfEmptyRow = items.findIndex((item) => !item.id);
    if (indexOfEmptyRow !== -1) {
      updateRow(indexOfEmptyRow, newItem);
    } else {
      setItems((prevItems: any) => [...prevItems, newItem]);
    }

    setShowCreateService(false);
  };

  const exchangeRate = formData.exchangeRate ?? 1;
  const [currentView, setCurrentView] = useState<
    | "selectItem"
    | "addInventory"
    | "productOptions"
    | "productVariants"
    | "viewSelectItems"
    | "showSelectedItem"
    | null
  >(null);
  // const [variationList, setVariationList] = useState<VariationItem[]>([]);
  const [selectedInventory, setSelectedInventory] = useState<IInventory | null>(
    null,
  );
  const [editInventory, setEditInventory] = useState<InventoryFormData | null>(
    null,
  );
  const [quantities, setQuantities] = useState<{ [key: string]: string }>({});

  return (
    <div className="">
      <div className="md:hidden lg:hidden">
        {/* <LineItemsSection
         padding="1em"
          formData={formData}
          setFormData={setFormData}
          variations={[]}
          total={selectedInventory?.total || 0}
        /> */}
      </div>

      <div className="hidden lg:block md:block">
        <FullScreenOverlay
          isOpen={showCreateInventory && isRetail}
          onClose={() => setShowCreateInventory(false)}
        >
          <CreateInventoryModal
            show={showCreateInventory}
            setShowCreateInventory={setShowCreateInventory}
            onCreateSuccess={handleCreateSuccess}
          />
        </FullScreenOverlay>

        <FullScreenOverlay
          isOpen={showCreateService}
          onClose={() => setShowCreateService(false)}
        >
          <CreateServiceModal
            show={false}
            setShowCreateService={setShowCreateService}
            //@ts-ignore
            onCreateSuccess={handleCreateServiceSuccess}
            serviceType={serviceType}
          />
        </FullScreenOverlay>
      </div>

      <div className="mt-[2em] relative hidden md:block">
        {isRetail ? (
          <LineItemTable
            columns={columns}
            items={items}
            isSearchInput={true}
            addItem={addItem}
            removeItem={removeItem}
            updateCell={updateCell}
            updateRow={updateRow}
            isImportedToInvoice={false}
            isInvoice={true}
            handleClearErrors={handleClearErrors}
            handleAdd={isRetail ? handleAddInventory : handleAddService}
            currency={formData.currency ?? ""}
            //   @ts-ignore
            exchangeRate={formData.exchangeRate}
          />
        ) : (
          <ServiceLineItemTable
            columns={column}
            items={formData.services}
            isSearchInput={true}
            addItem={addItem}
            removeItem={removeItem}
            updateCell={updateCell}
            updateRow={updateRow}
            isImportedToInvoice={false}
            selectedCurrencyLabel={selectedCurrencyLabel}
            handleClearErrors={handleClearErrors}
            isInvoice={true}
            handleAdd={isRetail ? handleAddInventory : handleAddService}
            currency={formData.currency ?? ""}
            serviceType={serviceType}
            //   @ts-ignore
            exchangeRate={formData.exchangeRate}
          />
        )}

        <div className="absolute mt-[-3em]">
          {validationResults.inventories && (
            <div className=" ml-4 xl:text-[14px] lg:text-[12px] biglg:text-[12px] 2xl:text-[14px] md:text-[11px] text-[9px]">
              <span className="text-red-500">
                {validationResults.inventories}
              </span>
            </div>
          )}
          {validationResults.services && (
            <div className="mt-[] ml-4 xl:text-[14px] lg:text-[12px] biglg:text-[12px] 2xl:text-[14px] md:text-[11px] text-[9px]">
              <span className="text-red-500">{validationResults.services}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LineTable;
